import { http, HttpResponse } from 'msw'

import type { UpdatePolicyParams } from '@/api/policies/update-policy'

export const mockUpdatePolicy = http.put<never, UpdatePolicyParams>(
  '/my-business/api/agency/v1/*/:companyAlphaId/policies/:policyAlphaId',
  async ({ request }) => {
    const { name } = await request.json()

    if (name === 'error') {
      return HttpResponse.json({ message: 'Error' }, { status: 400 })
    }

    return HttpResponse.json(null, { status: 200 })
  },
)
